module.exports = __webpack_public_path__ + "img/glow-yellow-medium.97fea920.png";